import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import GestionDeRutas from './functions/gestion_de_rutas';
import { AuthProvider } from './functions/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <AuthProvider>
      <GestionDeRutas></GestionDeRutas>
    </AuthProvider>
  </React.Fragment>
);

reportWebVitals();
